package pwgs.ui.scenes.playerslistscene

import kotlinx.serialization.Serializable
import visage.ds.forms.FieldModel
import visage.rmi.VisageController

@VisageController(PlayersListSceneProps::class, PlayersListSceneModel::class)
interface PlayersList {
    fun load()
}

@Serializable
class PlayersListSceneProps(val projectId: Long)

@Serializable
class PlayersListSceneModel(
    val searchResults: List<PlayersListItemModel>
) {
    var isLoading = true
    var searchFieldModel = FieldModel("")
}

@Serializable
class PlayersListItemModel(
    val id: String,
    val userName: String,
    val visibleName: String
)